import { EmailConfigurationModel } from "./types";

export const mockedEmailConfiguration: EmailConfigurationModel = {
  mailClient: {
    smtpServer: "smtp.mailserver.com",
    smtpPort: 587,
    username: "admin@firma.pl",
    password: "SuperHaslo123!",
    senderEmail: "no-reply@firma.pl",
    imapServer: "imap.mailserver.com",
    instructionVideo: "https://example.com/video/help-email-config",
  },

  recipient1: {
    recipientEmail: "ksiegowosc@firma.pl",
    ccEmail: "biuro@firma.pl",
    bccEmail: "archiwum@firma.pl",
    emailSubject: "Raport miesięczny",
    attachmentName: "raport.zip",
    defaultPassword: "1234567890",
    passwordRequired: true,
    emailBody: "Dzień dobry,\nW załączeniu przesyłamy raport miesięczny.",
    footer: "Z poważaniem,\nZespół EasyTacho",
  },

  recipient2: {
    recipientEmail: "hr@firma.pl",
    ccEmail: "",
    bccEmail: "",
    emailSubject: "Lista kierowców",
    attachmentName: "kierowcy.zip",
    defaultPassword: "",
    passwordRequired: false,
    emailBody: "W załączeniu znajduje się aktualna lista kierowców.",
    footer: "Dziękujemy,\nDział HR",
  },

  recipient3: {
    recipientEmail: "zarzad@firma.pl",
    ccEmail: "",
    bccEmail: "",
    emailSubject: "Zestawienie finansowe",
    attachmentName: "finanse.zip",
    defaultPassword: "NIP",
    passwordRequired: true,
    emailBody: "W załączeniu przesyłamy podsumowanie finansowe miesiąca.",
    footer: "EasyTacho Team",
  },

  imiSubmission: {
    recipientEmail: "imi@firma.pl",
    ccEmail: "admin@firma.pl",
    bccEmail: "",
    emailSubject: "Zgłoszenie IMI",
    attachmentName: "zgloszenie-imi.zip",
    defaultPassword: "NIP",
    passwordRequired: true,
    emailBody: "W załączeniu znajduje się zgłoszenie IMI dla kierowcy.",
    footer: "System EasyTacho - wysyłka automatyczna",
  },
};
